import en from "./locales/ko";

// Directly assign the 'en' object to 'strings'
const strings = en;

export default strings;
